module.exports = __webpack_public_path__ + "img/westonair.b76a9a70.jpg";